import * as Website from '../../Config/Website.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';



const preinit = () => {

}

const init = () => {
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {
  UpdateStatus.scroll();
}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
